<template>
    <PageLoader v-if="active === true" :siloData="siloData" :appState="appState" :active="active" :activator="type" :pageId="getPage" @close="$emit('close')" @updateState="updateState" @refreshData="refreshData" />
</template>

<script>
import PageLoader from "@c/PageLoader.vue";
import Icon from "@c/Icon.vue";
export default {
    components: {
        PageLoader,
        Icon,
    },
    computed: {
        getPage() {
            let returned = null;
            switch (this.type) {
                case 'terms':
                    returned = parseInt(this.siloData.urls.getterms);
                break;
                case 'goals':
                    returned = parseInt(this.siloData.urls.getgoals);
                break;
                case 'checkin':
                    returned = parseInt(this.siloData.urls.getcheckin);
                break;
                default:
                    returned = null;
                break;
            }
            return returned;
        }
    },
    props: {
        active: Boolean,
        siloData: Object,
        appState: String,
        pageId: Number,
        type: String,
    },
    methods: {
        updateState(newState) {
            this.$emit('updateState', newState);
        },
        refreshData(onComplete = null) {
            console.log('refreshing data (page)');
            this.$emit('refreshData', onComplete);
        },
    }
}
</script>